<template>
  <v-app style="width: 100vw;">
    <!-- Loading State -->
    <v-container v-if="configLoading" class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" class="text-center">
          <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
          <p class="mt-4 white--text">Loading...</p>
        </v-col>
      </v-row>
    </v-container>

    <!-- Error State -->
    <v-container v-else-if="configError" class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" md="6">
          <v-alert type="error">
            Failed to load site configuration. Please refresh the page.
            <br><small>{{ configError }}</small>
          </v-alert>
          <v-btn color="primary" @click="retry" class="mt-3">Retry</v-btn>
        </v-col>
      </v-row>
    </v-container>

    <!-- Main Content (when config loaded) -->
    <template v-else>
      <!-- Header/Navigation - hide on admin routes -->
      <v-container v-if="!hideNavigation" style="width: 100vw;" class="banner-gradient">
        <div class="royale-header"> Battle Royale </div>
        <div class="boston-header"> Boston </div>

        <v-app-bar
          style="background: transparent; width:100vw;"
          light
          class="elevation-0"
          v-if="isNotMobile"
        >
          <v-row style="width: 100vw;" class="justify-start" align="center">
            <v-col v-for="button in buttons" :key="button.text" cols="auto">
              <v-btn
                plain
                :to="button.routePath"
                class="router-button basker-text ka-0 pa-0"
              >{{ button.text }}</v-btn>
            </v-col>
            <v-col cols="auto">
              <ColorButton :url="donateLink" :text="donateButtonText"></ColorButton>
            </v-col>
          </v-row>
        </v-app-bar>

        <div v-else>
          <v-app-bar style="opacity: 0.38; width:100vw;">
            <v-app-bar-nav-icon variant="text" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
          </v-app-bar>
          <v-navigation-drawer
            v-model="drawer"
            location="bottom"
            style="background: transparent; overflow: auto; overflow-y: auto;"
          >
            <v-list v-show="drawer">
              <v-list-item v-for="button in buttons" :key="button.text" :title="button.text" :value="button.routePath">
                <ColorButton :url="'#/' + button.routePath" :text="button.text"/>
              </v-list-item>
              <v-list-item>
                <ColorButton :url="donateLink" :text="donateButtonText"></ColorButton>
              </v-list-item>
            </v-list>
          </v-navigation-drawer>
        </div>
      </v-container>

      <!-- Admin routes get full control of layout -->
      <router-view v-if="hideNavigation"/>

      <!-- Normal routes use v-main wrapper -->
      <v-main v-else style="width: 100vw; display: block; margin: 0;">
        <router-view style="width: 100vw; margin: 0;"/>
        <div class="footer"></div>
      </v-main>
    </template>
  </v-app>
</template>

<script>
import ColorButton from '@/components/ColorButton'
import { mapState } from 'vuex'

export default {
  name: 'App',
  components: {
    ColorButton
  },
  data: () => ({
    buttons: [
      { "text": "Tickets", "routePath": "Home" },
      { "text": "Contact", "routePath": "Contact" },
      { "text": "Register", "routePath": "Rules" },
      { "text": "Sponsors", "routePath": "Sponsors" },
    ],
    drawer: false,
    isNotMobile: false
  }),
  computed: {
    ...mapState(['donateLink', 'donateButtonText', 'configLoading', 'configError']),
    hideNavigation() {
      return this.$route.meta.hideNavigation
    }
  },
  beforeMount() {
    this.handleResize()
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.isNotMobile = window.innerWidth >= 768;
    },
    retry() {
      this.$store.dispatch('fetchConfig')
    }
  }
};
</script>

<style>
</style>
